


import React from "react";
import "./WhyChooseUs.css";

import {
  FaUserTie,
  FaPlaneDeparture,
  FaRoute,
  FaCarSide,
} from "react-icons/fa";

const WhyChooseUs = () => {
  const features = [
    {
      icon: <FaUserTie />,
      title: "Professional Chauffeurs",
      text:
        "Experienced, licensed and courteous drivers ensuring every journey is safe, comfortable and punctual.",
    },

    {
      icon: <FaPlaneDeparture />,
      title: "Airport Transfer Experts",
      text:
        "Reliable Mumbai & Navi Mumbai airport pickup and drop services with on-time arrivals and departures.",
    },

    {
      icon: <FaRoute />,
      title: "Local & Outstation Travel",
      text:
        "Comfortable taxi services for city rides, business travel, family trips, weekend getaways and Pan India tours.",
    },

    {
      icon: <FaCarSide />,
      title: "Premium Fleet",
      text:
        "Choose from Swift Dzire, Ertiga, Toyota Rumion, Kia Carens, Innova, Innova Crysta, Tempo Traveller, Urbania and Mini Bus.",
    },
  ];

  return (
    <section className="why-section p-0 pt-2">
      <div className="container">

        <div className="why-grid">

          {/* ================= CONTENT ================= */}
          <div className="why-content">

            <div className="why-heading">

              <div className="heading-lines">
                <span></span>
                <span></span>
                <span></span>
              </div>

              <h2>
                Why Choose
                <span> Shreesha Tours & Travels?</span>
              </h2>

            </div>

            <p className="why-description">
              Discover the difference with our customer-first approach,
              premium vehicles, and seamless rental experience designed for
              modern travelers.
            </p>

         <ul className="feature-list">
  {features.map((item, index) => (
    <li key={index}>

      <div className="feature-icon">
        {item.icon}
      </div>

      <div className="feature-content">
        <h3>{item.title}</h3>

        <p>{item.text}</p>
      </div>

    </li>
  ))}
</ul>


          </div>


          {/* ================= IMAGES ================= */}
          <div className="why-images">

            <div className="image-one">
              <img
                src="/images/why-choose-us1.jpg"
                alt="Shreesha Tours and Travels"
              />
            </div>

            <div className="image-two">
              <img
                src="/images/why-choose-us2.jpg"
                alt="Premium cab service"
              />
            </div>

            <div className="image-three">
              <img
                src="/images/why-choose-us3.jpg"
                alt="Professional travel service"
              />
            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
